export const DEBOUNCE_IN_MS = 500;
export const DEBOUNCE_SEARCH_IN_MS = 200;
